import {
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function PaymentMethod({ paymentMethod, setPaymentMethod }) {
  const { orders } = useSelector((store) => store.order);
  const { t } = useTranslation();
  const cashOnDelivery = orders.some((order) => order.order_status === 'delivered');
  useEffect(() => {
    if (!cashOnDelivery && Number(paymentMethod) === 1) setPaymentMethod(0);
  }, [cashOnDelivery, paymentMethod, setPaymentMethod]);
  const handlePaymentMethodChange = (event) => setPaymentMethod(Number(event.target.value));

  return (
    <CardContent>
      <Typography variant="h6" gutterBottom>
        {t("checkout.payment_options")}
      </Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={paymentMethod}
          name="radio-buttons-group"
        >
          <FormControlLabel
            key={0}
            value={0}
            control={<Radio />}
            label={t("checkout.credit_card")}
            onChange={(event) => handlePaymentMethodChange(event)}
          />

          {cashOnDelivery &&

          <FormControlLabel
            key={1}
            value={1}
            control={<Radio />}
            label={t("checkout.cash_on_delivery")}
            onChange={(event) => handlePaymentMethodChange(event)}
          />

          }
         
        </RadioGroup>
      </FormControl>
    </CardContent>
  );
}

export default memo(PaymentMethod);
